import * as React from 'react'
import moment from 'moment'
import { IBuildedTour, IFilterOptions } from 'utils/weeklyTypes'

interface IWeeklyContextType {
  // フィルター状態
  filterOptions: IFilterOptions
  setFilterOptions: React.Dispatch<React.SetStateAction<IFilterOptions>>

  // 選択されたツアー
  selectedTour: IBuildedTour | null
  setSelectedTour: React.Dispatch<React.SetStateAction<IBuildedTour | null>>

  // 開始日
  startDate: moment.Moment
  setStartDate: React.Dispatch<React.SetStateAction<moment.Moment>>

  // 全ツアーデータ
  allTours: IBuildedTour[]
  setAllTours: React.Dispatch<React.SetStateAction<IBuildedTour[]>>

  // カレンダーメモ
  calendarMemos: any[]
  setCalendarMemos: React.Dispatch<React.SetStateAction<any[]>>

  // ツアー更新関数
  onTourUpdate: (updatedTour: IBuildedTour) => void

  // ツアー再取得関数
  refetchTour: (tour_id: number) => void
}

const WeeklyContext = React.createContext<IWeeklyContextType | undefined>(undefined)

export const useWeeklyContext = (): IWeeklyContextType => {
  const context = React.useContext(WeeklyContext)
  if (context === undefined) {
    throw new Error('useWeeklyContext must be used within a WeeklyProvider')
  }
  return context
}

export default WeeklyContext
